import React from 'react'
import { Alert, Button, Space, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

const { Text } = Typography

interface DimensionEditModeBarProps {
  onDone: () => void
}

const DimensionEditModeBar: React.FC<DimensionEditModeBarProps> = ({ onDone }) => {
  const { t } = useTranslation()

  return (
    <Alert
      type="info"
      style={{ marginBottom: 12 }}
      message={
        <Space wrap style={{ justifyContent: 'space-between', width: '100%' }} align="baseline">
          <Space align="baseline">
            <Text strong>{t('dimensionsPage:editModeLabel')}</Text>
            <Text type="secondary">{t('dimensionsPage:editModeAutosaveHint')}</Text>
          </Space>
          <Button type="primary" onClick={onDone}>
            {t('dimensionsPage:editModeDone')}
          </Button>
        </Space>
      }
    />
  )
}

export default DimensionEditModeBar
